//Comentario necesario para codificación en UTF-8, ver Inc6743
"use strict";

(function() {
	angular.module('pphhApp')
		.factory("DashboardService", ["$http",
			function($http) {
				return {
					getPendingTasks: function(filter) {
						var request = {
							method: "GET",
							url: "/dashboard/tasks",
							params: filter
						};
						return $http(request);
					},

					getPendingMonitorTasks: function(filter) {
						var request = {
							method: "GET",
							url: "/activityMonitor/tasks",
							params: filter
						};
						return $http(request);
					},

					getActivityMonitorDh: function(moduleName) {
						var request = {
							method: "GET",
							url: "/activityMonitor/tasks/activityMonitorDh",
							params: {
								module: moduleName
							}
						};
						return $http(request);
					},
					
					getActivityMonitorCcaa: function(moduleName) {
						var request = {
							method: "GET",
							url: "/activityMonitor/tasks/activityMonitorCcaa",
							params: {
								module: moduleName
							}
						};
						return $http(request);
					},
					
					getActivityTypes: function(moduleName) {
						var request = {
							method: "GET",
							url: "/dashboard/tasks/activityTypes",
							params: {
								module: moduleName
							}
						};
						return $http(request);
					},

					getActivityTypeStates: function(moduleName, activityType) {
						var request = {
							method: "GET",
							url: "/dashboard/tasks/activityTypeStates",
							params: {
								activityType: activityType,
								module: moduleName
							}
						};
						return $http(request);
					},

					getActivityProgress: function(activityId) {
						return $http.get("/dashboard/tasks/" + activityId + "/progress");
					},

					getActivity: function(activityId) {
						return $http.get("/dashboard/tasks/" + activityId);
					}
				}
			}
		]);
})();
